module.exports = __webpack_public_path__ + "img/attachments_1.27cd283f.svg";